export function formatContractOptionLabel(contract: any): string {
  const lead = contract.lead ?? {};
  const customerName = [
    lead.contactName,
    [lead.name, lead.surname].filter(Boolean).join(" "),
    lead.companyName,
  ].find(Boolean);
  const location = [lead.address, lead.city, lead.state].filter(Boolean).join(", ");
  const details = [customerName, location].filter(Boolean).join(" - ");
  const baseLabel = `N${contract.contractN}`;

  return details ? `${baseLabel} - ${details}` : baseLabel;
}
